module.exports = __webpack_public_path__ + "static/media/winterweave-1.39c46b11.jpg";